/**
 * 基础菜单 商品管理
 */
<template>
  <div class="dashboard-container">
    <!-- 头部内容 -->
    <el-card class="header-card">
       <div slot="header" class="clearfix">
      <span>通知</span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="open">通知内容</el-button>
    </div>
      <div>
         {{tongz}}  
      </div>
    </el-card>
    <!-- 主要内容 -->
    <el-row type="flex" justify="space-between">
      <!-- 左侧内容 -->
      <el-col :span="13" style="padding-right: 26px">
        <!-- 工作日历 -->
        <el-card class="box-card">
          <div slot="header" class="header">
            <span>工作日历</span>
          </div>
          <!-- 放置日历组件 -->
          <work-calendar></work-calendar>
        </el-card>
        <!-- 公告 -->
      
      </el-col>
      <!-- 右侧内容 -->
      <el-col :span="11">
        <!-- 绩效指数 -->
        <el-card class="box-card">
          <div slot="header" class="header">
            <span>当日数据</span>
          </div>
          <!-- 放置雷达图 -->
          <!-- <Radar></Radar> -->
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { deptList, deptSave, deptDelete,getMenuApp,login } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import axios from 'axios';
import WorkCalendar from "../../components/work-calendar";
//import Radar from "../../components/radar";
export default {
  data() {
    return {
      nshow: true, //switch开启
      tongz:"",
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入物料名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入物料代码', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
	  dynamicValidateForm:[],
      // 删除物料
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
	   user: {},
      userparm: [], //搜索权限
      listData: [], //用户数据
      v_str_AccountID:165
    }
  },
  // 注册组件
  components: {
    Pagination,
	WorkCalendar,
	//Radar,
  },
  /**
   * 数据发生改变
   */
  /**
   * 创建完毕
   */
  created() {
	  this.user = JSON.parse(localStorage.getItem('userdata'))
	  console.log( this.user)
		this.getdata(this.formInline)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    open(){
      this.$prompt('请输入通知内容', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          let phemss = {
            'v_str_AccountID': this.v_str_AccountID,
            'jsSQL': "{\"SQL\":[{\"select\":\" insert into A_TZ(LContext,LDate) values ('"+value+"',GETDATE())\"}]}"
          }
          login(phemss).then(res => {
			     this.getdata();
		   	})
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    },
    // 获取公司列表
    getdata(parameter) {
      let phemss = {
            'v_str_AccountID': this.v_str_AccountID,
            'jsSQL': "{\"SQL\":[{\"select\":\" select top 1 * from  A_TZ order by LItemID desc\"}]}"
          }
          login(phemss).then(res => {
           let arr=res.Data.Table[0];
           this.tongz=arr.LContext
		   	})
       
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
	ahrouter(PLName,kLName){
		console.log(kLName.FURL)
		//this.$router.replace( kLName.FURL)
		this.$router.push({
			path: kLName.FURL
			// query: {
			// 	LItemID: this.multipleSelection[0].LItemID,
			// 	L_BillNo: this.multipleSelection[0].L_BillNo,
			// 	L_Date: this.multipleSelection[0].L_Date
			// }
		})
		
	},
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
 .el-card__body{
    padding: 0px 0px 10px 10px;
  }
  .el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      margin: 10px 0;
  }
  div.hovetycolor:hover{
	  color: dodgerblue;
	  
  }
  .dashboard-container {
    margin: 10px;
    li {
      list-style: none;
    }
    .headImg {
      float: left;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background: #999;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  
    .headInfoTip {
      padding: 25px 0 0;
      margin-left: 120px;
      p {
        padding: 0 0 15px;
        margin: 0;
        &.firstChild {
          font-size: 24px;
        }
        &.lastChild {
          font-size: 20px;
          color: #7f8c8d;
        }
      }
    }
  }
  
  .box-card {
    padding: 5px 10px;
    margin-top: 20px;
    .header {
      span {
        color: #2c3e50;
        font-size: 24px;
      }
      .item {
        color: #97a8be;
        float: right;
        padding: 3px 0;
      }
    }
    .headTit {
      span {
        border-bottom: 4px solid #8a97f8;
        padding-bottom: 10px;
      }
    }
  }
  .header-card {
    position: relative;
    .header {
      position: absolute;
      right: 20px;
      top: 15px;
      z-index: 1;
    }
  }
  
  .advContent {
    background: #fff;
    border-radius: 5px 5px 0px 0px;
    .title {
      font-size: 16px;
      padding: 20px;
      font-weight: bold;
      border-bottom: solid 1px #ccc;
    }
    .contentItem {
      padding: 0 30px;
      min-height: 350px;
      .item {
        display: flex;
        padding: 18px 0 10px;
        border-bottom: solid 1px #ccc;
        .col {
          color: #8a97f8;
        }
        img {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          margin-right: 10px;
        }
        p {
          padding: 0 0 8px;
        }
      }
    }
  }
  .noticeList {
    margin: 0;
    padding: 0;
  }
  .sideNav,
  .sideLink {
    padding: 30px 0 12px;
    .sideBtn {
      padding: 16px 21px;
      font-size: 16px;
      margin: 10px 5px;
    }
  }
  .sideLink {
    text-align: center;
    .icon {
      display: inline-block;
      width: 76px;
      height: 76px;
      background: url("./../../assets/common/icon.png") no-repeat;
    }
    .iconGuide {
      background-position: 0 0;
    }
    .iconHelp {
      background-position: -224px 0;
    }
    .iconTechnology {
      background-position: -460px 0;
    }
  }
</style>

 
 


// WEBPACK FOOTER //
// src/views/goods/Goods.vue